import { IServiceProgramState, IStoreState } from '../../../types'
import {
  IServiceProgramAction,
  IServiceProgramDeleteFail,
  IServiceProgramDeleteSuccess,
  IServiceProgramListFail,
  IServiceProgramListSuccess,
  IServiceProgramUpdateFail,
  IServiceProgramUpdateSuccess
} from '../../actions/service-program/service-program'
import {
  SERVICE_PROGRAM_DELETE_FAIL,
  SERVICE_PROGRAM_DELETE_REQUEST,
  SERVICE_PROGRAM_DELETE_SUCCESS,
  SERVICE_PROGRAM_FAIL,
  SERVICE_PROGRAM_REQUEST,
  SERVICE_PROGRAM_SUCCESS,
  SERVICE_PROGRAM_UPDATE_FAIL,
  SERVICE_PROGRAM_UPDATE_REQUEST,
  SERVICE_PROGRAM_UPDATE_SUCCESS
} from '../../constants'
import { IServiceProgramObject } from '../../../types/service-program'

const initialState = {
  items: {},
  metadata: {
    fetching: false,
    fetchingError: '',
    processing: false,
    processingError: ''
  }
}

function serviceProgramRequest(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      fetching: true
    }
  })
}

function serviceProgramRequestSuccess(
  state: IServiceProgramState,
  action: IServiceProgramAction
): IServiceProgramState {
  const items = (action as IServiceProgramListSuccess).items
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      fetching: false,
      fetchingError: ''
    },
    items: {
      ...state.items,
      ...items
    }
  })
}

function serviceProgramRequestFail(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  const error = (action as IServiceProgramListFail).error
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      fetching: false,
      fetchingError: error
    }
  })
}

function serviceProgramUpdate(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: true
    }
  })
}

function serviceProgramUpdateSuccess(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  const item = (action as IServiceProgramUpdateSuccess).item
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: false
    },
    items: {
      ...state.items,
      [item.id]: item
    }
  })
}

function serviceProgramUpdateFail(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  const error = (action as IServiceProgramUpdateFail).error
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: false,
      processingError: error
    }
  })
}

function serviceProgramDelete(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: true
    }
  })
}

function serviceProgramDeleteSuccess(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  const id = (action as IServiceProgramDeleteSuccess).id
  delete state.items[id]
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: false,
      processingError: ''
    },
    items: state.items
  })
}

function serviceProgramDeleteFail(state: IServiceProgramState, action: IServiceProgramAction): IServiceProgramState {
  const error = (action as IServiceProgramDeleteFail).error
  return Object.assign({}, state, {
    metadata: {
      ...state.metadata,
      processing: false,
      processingError: error
    }
  })
}

export function serviceProgram(
  state: IServiceProgramState = initialState,
  action: IServiceProgramAction
): IServiceProgramState {
  switch (action.type) {
    case SERVICE_PROGRAM_REQUEST: {
      return serviceProgramRequest(state, action)
    }
    case SERVICE_PROGRAM_SUCCESS: {
      return serviceProgramRequestSuccess(state, action)
    }
    case SERVICE_PROGRAM_FAIL: {
      return serviceProgramRequestFail(state, action)
    }
    case SERVICE_PROGRAM_UPDATE_REQUEST: {
      return serviceProgramUpdate(state, action)
    }
    case SERVICE_PROGRAM_UPDATE_SUCCESS: {
      return serviceProgramUpdateSuccess(state, action)
    }
    case SERVICE_PROGRAM_UPDATE_FAIL: {
      return serviceProgramUpdateFail(state, action)
    }
    case SERVICE_PROGRAM_DELETE_REQUEST: {
      return serviceProgramDelete(state, action)
    }
    case SERVICE_PROGRAM_DELETE_SUCCESS: {
      return serviceProgramDeleteSuccess(state, action)
    }
    case SERVICE_PROGRAM_DELETE_FAIL: {
      return serviceProgramDeleteFail(state, action)
    }
    default:
      return state
  }
}

export const getServiceProgramListFetching = (state: IStoreState): boolean => {
  return state.serviceProgram.metadata.fetching
}

export const getServiceProgramListFetchingError = (state: IStoreState): string => {
  return state.serviceProgram.metadata.fetchingError
}

export const getAllServicePrograms = (state: IStoreState): IServiceProgramObject[] => {
  return Object.values(state.serviceProgram.items)
}

export const getServiceProgram = (state: IStoreState, id: string): IServiceProgramObject => {
  return state.serviceProgram.items[id]
}

export const getServiceProgramProcessing = (state: IStoreState): boolean => {
  return state.serviceProgram.metadata.processing
}

export const getServiceProgramProcessingError = (state: IStoreState): string => {
  return state.serviceProgram.metadata.processingError
}



// WEBPACK FOOTER //
// ./src/state/reducers/service-program/service-program.ts